import { toast } from 'src/components/ui/toast';

export function beginPolicyOverrideEdit<Row>(
  row: Row,
  setEditing: (row: Row) => void,
  setScalarField: (value: string) => void,
  scalar: string,
  window: { adopt: (row: Row) => void },
): void {
  setEditing(row);
  setScalarField(scalar);
  window.adopt(row);
}

export function policyOverrideMutationHandlers(
  reset: () => void,
  formatError: (e: Error) => string,
): {
  onSaved: (message: string) => void;
  onError: (e: Error) => void;
} {
  return {
    onSaved(message: string) {
      toast.success(message);
      reset();
    },
    onError(e: Error) {
      toast.error(formatError(e));
    },
  };
}
